import { GridFilterModel } from '@mui/x-data-grid-pro';

export const EMAIL_OR_ALIAS_SEARCH_FIELD = 'emailOrAlias';

export const aliasFilterOperatorValues = ['contains', 'equals'];

export function toServerFilterModel(
  gridFilterModel: GridFilterModel
): GridFilterModel {
  const searchTerm = gridFilterModel.quickFilterValues?.[0];

  const items = gridFilterModel.items.filter(
    (item) =>
      item.field !== EMAIL_OR_ALIAS_SEARCH_FIELD &&
      item.value !== null &&
      item.value !== undefined &&
      item.value !== ''
  );

  if (searchTerm) {
    items.push({
      field: EMAIL_OR_ALIAS_SEARCH_FIELD,
      operator: 'contains',
      value: searchTerm,
    });
  }

  return { ...gridFilterModel, items };
}
